import View from './View';

export * from './components';

export default View;
